import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { DeviceDetectorService, DeviceInfo } from 'ngx-device-detector';
import { share } from 'rxjs/operators';
import { AuthService } from '../shared/services/auth.service';
import { LocaleService } from '../shared/services/locale.service';
import { ViewportService } from '../shared/services/viewport.service';
import { User } from '@core/models';
@Component({
	selector: 'app-home-head',
	templateUrl: './home-head.component.html',
	styleUrls: ['./home-head.component.scss'],
})
export class HomeHeadComponent implements OnInit {
	selectedVal: string;
	deviceInfo: DeviceInfo;
	data: any;
	user: User = this.auth.user();

	constructor(
		private deviceDetectorService: DeviceDetectorService,
		public router: Router,
		public route: ActivatedRoute,
		public locale: LocaleService,
		public viewport: ViewportService,
		private auth: AuthService
	) {}

	ngOnInit(): void {
		(queries: Params) => {
			if (queries['selectedValue'] !== undefined) {
				this.selectedVal = queries['selectedValue'];
			}
		};
	}
}
